var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.38-181.54V-200l60-40q-48.23 0-81.8-33.58Q200-307.15 200-355.38V-720q0-63.77 65.46-91.88Q330.92-840 480-840q150.46 0 215.23 27.77Q760-784.46 760-720v364.62q0 48.23-33.58 81.8Q692.85-240 644.62-240l60 40v18.46H255.38ZM240-520h480v-178.46H240V-520Zm404.62 40H240h480-75.38ZM511.73-348.27q12.89-12.88 12.89-31.73t-12.89-31.73q-12.88-12.89-31.73-12.89t-31.73 12.89q-12.89 12.88-12.89 31.73t12.89 31.73q12.88 12.89 31.73 12.89t31.73-12.89ZM315.38-280h329.24Q676-280 698-302q22-22 22-53.38V-480H240v124.62Q240-324 262-302q22 22 53.38 22ZM480-800q-109.85 0-166.73 15-56.89 15-69.12 46.54h472.62Q705.69-770 648.81-785 591.92-800 480-800Zm0 61.54H716.77 244.15 480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetro);
export default __webpack_public_path__ + "static/media/metro.5d3e70d5378cc8507905bdc1798d5925.svg";
export { ForwardRef as ReactComponent };